const VERSION = "3.1.0";
export {
  VERSION
};
